const __WEBPACK_NAMESPACE_OBJECT__ = require("react-toastify/dist/ReactToastify.css");